import React, { useMemo, useState } from 'react';
import { Widget, Table, Col, Row, Button, FormInput, Form, FormResetButton, FormSelect } from '@digital/ui';
import { Collapse, Tooltip, Icon } from 'antd';
import { concluidos } from '@app/api/suprimentos';
import { TipoDemanda } from '@app/api/demanda';
import { getAllUsuariosSuprimentosptions } from '@app/api/usuario';
import { compareBoolean, compareText } from '@app/helpers/comparators';
import { ColumnProps } from 'antd/lib/table';
import { hasPermission } from '@app/helpers/permissions';

const AbaConcluido = () => {
  const [dados, setDados] = useState([]);

  const { Panel } = Collapse;

  useMemo(() => {
    concluidos().then(data => setDados(data));
  }, []);

  const columns: ColumnProps<any>[] = [
    {
      title: 'Código',
      dataIndex: 'identificadorTexto',
      sorter: (a, b) => compareText(a.identificadorTexto, b.identificadorTexto),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.identificadorTexto !== undefined &&
        record.identificadorTexto.toString().toLowerCase().includes(value.toLowerCase()),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Código"
              name="identificadorTexto"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => {})}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
    },
    {
      title: 'Demandante',
      dataIndex: 'demandante',
      sorter: (a, b) => compareText(a.demandante, b.demandante),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.demandante !== undefined && record.demandante.toString().toLowerCase().includes(value.toLowerCase()),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Demandante"
              name="demandante"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => {})}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
    },
    {
      title: 'Tipo',
      dataIndex: 'tipo',
      render: (index, record) => TipoDemanda[record.tipo],
      sorter: (a, b) => compareText((a.tipo ? TipoDemanda[a.tipo] : ''), (b.tipo ? TipoDemanda[b.tipo] : '')),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        TipoDemanda[record.tipo] !== undefined &&
        TipoDemanda[record.tipo].toString().toLowerCase().includes(value.toLowerCase()),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Tipo"
              name="identificadorTexto"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => {})}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
    },
    {
      title: 'Tipo Serviço',
      dataIndex: 'tipoServico',
      sorter: (a, b) => compareText(a.tipoServico, b.tipoServico),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.tipoServico !== undefined && record.tipoServico.toString().toLowerCase().includes(value.toLowerCase()),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Tipo Serviço"
              name="tipoServico"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => {})}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
    },
    {
      title: 'Valor Final',
      dataIndex: 'expectativaValorFinal',
      render: (index, record) => {
        const finalValue = 'R$ ' + record.expectativaValorFinal;
        return finalValue.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      },
    },
    {
      title: 'PTR',
      dataIndex: 'haveraMaoDeObraEmPTR',
      render: (index, record) => (record.haveraMaoDeObraEmPTR ? 'Sim' : 'Não'),
      sorter: (a, b) => compareBoolean(a.haveraMaoDeObraEmPTR, b.haveraMaoDeObraEmPTR),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        (record.haveraMaoDeObraEmPTR === undefined && value === 'false') ||
        (record.haveraMaoDeObraEmPTR !== undefined &&
          record.haveraMaoDeObraEmPTR.toString().toLowerCase().includes(value.toLowerCase())),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormSelect
              placeholder="Pesquisar PTR"
              name="haveraMaoDeObraEmPTR"
              style={{ marginTop: '15px' }}
              onSelect={e => (setSelectedKeys ? setSelectedKeys(e ? [e] : []) : () => {})}
              options={[
                { text: 'Sim', value: 'true' },
                { text: 'Não', value: 'false' },
              ]}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
    },
    {
      title: 'SLA',
      dataIndex: 'haveraSla',
      render: (index, record) => (record.haveraSla ? 'Sim' : 'Não'),
      sorter: (a, b) => compareBoolean(a.haveraSla, b.haveraSla),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        (record.haveraSla === undefined && value === 'false') ||
        (record.haveraSla !== undefined && record.haveraSla.toString().toLowerCase().includes(value.toLowerCase())),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormSelect
              placeholder="Pesquisar SLA"
              name="haveraSla"
              style={{ marginTop: '15px' }}
              onSelect={e => (setSelectedKeys ? setSelectedKeys(e ? [e] : []) : () => {})}
              options={[
                { text: 'Sim', value: 'true' },
                { text: 'Não', value: 'false' },
              ]}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
    },
    {
      title: 'RC',
      dataIndex: 'requisicaoCompra',
      sorter: (a, b) => compareText(a.requisicaoCompra, b.requisicaoCompra),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.requisicaoCompra !== undefined &&
        record.requisicaoCompra.toString().toLowerCase().includes(value.toLowerCase()),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar RC"
              name="requisicaoCompra"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => {})}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
    },
    {
      title: 'OC',
      dataIndex: 'ordemCompra',
      sorter: (a, b) => compareText(a.ordemCompra, b.ordemCompra),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.ordemCompra !== undefined && record.ordemCompra.toString().toLowerCase().includes(value.toLowerCase()),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar OC"
              name="ordemCompra"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => {})}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
    },
    // {
    //   title: 'Status',
    // },
    {
      title: 'Responsável GPC',
      dataIndex: 'responsavelGpcNome',
      width: '10%',
      sorter: (a, b) => compareText(a.responsavelGpcNome, b.responsavelGpcNome),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.responsavelGpcNome !== undefined &&
        record.responsavelGpcNome.toString().toLowerCase().includes(value.toLowerCase()),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Responsável GPC"
              name="responsavelGpcNome"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => {})}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
    },
    {
      title: 'Comprador',
      dataIndex: 'compradorId',
      width: '15%',
      render: (index, record) => {
        return (
          <Form>
            <FormSelect
              value={record.compradorId}
              getOptions={getAllUsuariosSuprimentosptions}
              name="compradorId"
              disabled={!hasPermission(['SAS_ALTERAR_COMPRADOR'])}
            />
          </Form>
        );
      },
      sorter: (a, b) => compareText(a.compradorNome, b.compradorNome),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) => record.compradorId !== undefined && record.compradorId === value,
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormSelect
              placeholder="Pesquisar Comprador"
              name="compradorId"
              style={{ marginTop: '15px' }}
              onSelect={e => (setSelectedKeys ? setSelectedKeys(e ? [e] : []) : () => {})}
              getOptions={getAllUsuariosSuprimentosptions}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
    },
    {
      title: 'Gov. Aprovação',
    },
    {
      title: 'DDI',
    },
    {
      title: 'Ações',
      render: (index, record) => (
        <Tooltip title="Ir para Demanda">
          <Button
            type="link"
            icon="arrows-circled_up_right_2"
            name="irparaBm"
            onClick={() => {
              let urlBase = window.location.origin;
              window.open(urlBase + `/demanda/questionario/${record.id}`);
            }}
            href="#"
          />
        </Tooltip>
      ),
      width: '1%',
    },
  ];

  return (
    <Collapse bordered={false} activeKey={['concluidos']} expandIcon={() => <Icon type="arrows-right_4" />}>
      <Panel key="concluidos" header={'CONCLUÍDOS'}>
        <Widget>
          <Row>
            <Col>
              <Table columns={columns} dataSource={dados} pagination={false} />
            </Col>
          </Row>
        </Widget>
      </Panel>
    </Collapse>
  );
};
export default AbaConcluido;
